export default class BinaryData {

    public fileName: string = "";
    public contentType: string = "";
    public data: string | ArrayBuffer | null = null;
}